import './App.css';
import React from 'react';
import Home from './components/home';
import Projects from './components/projects';
import AboutMe from './components/aboutme';
import Resume from './components/aboutme/resources/FrancoCanalejoResume.docx';
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

function App() {
  return (
    <Layout></Layout>
  );
}

function cvDownloaded() {
  fetch('https://maker.ifttt.com/trigger/cv_dld/with/key/D7aCXeY6FGCZlzNWowwAt',
  {
    mode: 'no-cors',
  })
  .then(res => res.status === 200? console.log("CV Downloaded !") : console.log("!"))
  logEvent(analytics, "select_item", {item_list_id: 0,item_list_name: "CV Downloaded!"});
}


class NavBar extends React.Component {
  render() {
    const tabs = this.props.tabs.slice();
    return (
      <header className={`bg-${tabs[this.props.active].color}`}>
        <nav>
          <ul>
            {
              this.props.active === 0? 
              <li key={0} >
                <div key={1} className={`card nav-item shadow-${tabs[this.props.active].color} bg-${tabs[this.props.active].color}`}>
                  <a key={1} 
                  onClick={(u) => {cvDownloaded()}} download='Franco-Canalejo_resume' href={Resume}>Download Resume</a>
                </div>
              </li> : null
            }
            {tabs.map((tabName, tab) => {
              document.querySelector('html').removeAttribute('class');
              document.querySelector('html').classList.add(`bg-${tabs[this.props.active].color}`);
              return (
              <li key={tab + 1} onClick={() => this.props.onClick(tab)} className={`${tab === this.props.active? "active" : ""} ${this.props.active === tab && tab === 0? "hide" : ""}`}>
                <div key={tab + 1} className={`card nav-item shadow-${tabs[this.props.active].color} bg-${tabs[this.props.active].color}`}>
                  <p key={tab + 1}>{tabName.name}</p>
                </div>
              </li>
              )})
              }
          </ul>
        </nav>
      </header>
    );
  }
}



class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: 1,
      aux: 1
    }
  }

  setView(view) {
    this.setState({
      aux: view
    }) 
    setTimeout(() => {
      this.setState({
        currentView: view,
      }) 
    }, 1500);
    
  }
  render() {
    const headerTabs = [
      {
        name: "About Me",
        color: "orange"
      },
      {
        name: "Home",
        color: "blue"
      }, 
      {
        name: "Work",
        color: "green"
      }
    ];
    const views = [
      <AboutMe key={1}></AboutMe>,
      <Home key={2}></Home>, 
      <Projects key={3}></Projects>, 
  ];
    const anViews = [
      "About Me",
      "Home",
      "Projects"
    ]
    return [
        <NavBar 
        key={1} 
        tabs={headerTabs} 
        active={this.state.currentView} 
        onClick={(i) => {
          this.setView(i); 
          logEvent(analytics, "page_view",
          {
            page_location: views[i],
            page_title: anViews[i]
          })}}></NavBar>,
        <main key={2}>
          <div className={`slideIn-${this.state.aux === 0? "left" : this.state.aux === 2? "right" : "centre"} ${this.state.currentView !== this.state.aux? "leaveView" : ""}`}>
          {views[this.state.currentView]}
          </div>
        </main>,
     
    ]
  }
}
export default App;



